module.exports = __webpack_public_path__ + "static/media/plus.bold.d63f468f.svg";